export const ActiveCategories = {
  Legal: 'Legal',
  HomeInspection: 'Home Inspection',
  Cleaning: 'Cleaning',
  Appraisal: 'Appraisal',
  Surveying: 'Surveying',
  Staging: 'Staging',
  Painting: 'Painting',
  Moving: 'Moving',
  Mortgages: 'Mortgages',
};

export default {
  ActiveCategories,
};
